export const ExportSelections = {
  CurrentSelection: 'CurrentSelection',
  CurrentPage: 'CurrentPage',
  CurrentFilters: 'CurrentFilters',
  AllOrders: 'AllOrders'
}
